import { createElement } from 'react';

/** Static street map from the tracking design; a real map needs a maps provider (not integrated yet). */
const MAP_SVG = `
<rect width="390" height="380" fill="#E6F0F6"/>
<path d="M-10 90 L400 60 M-10 220 L400 250 M80 -10 L120 400 M250 -10 L230 400 M330 -10 L360 400" stroke="#FFFFFF" stroke-width="14"/>
<path d="M-10 160 L400 150 M170 -10 L160 400" stroke="#FFFFFF" stroke-width="22"/>
<rect x="20" y="20" width="44" height="54" rx="6" fill="#D3E5EF"/><rect x="190" y="80" width="54" height="56" rx="6" fill="#D3E5EF"/><rect x="270" y="170" width="44" height="64" rx="6" fill="#CFE5DC"/><rect x="30" y="250" width="70" height="60" rx="6" fill="#CFE5DC"/>
<path d="M95 300 C110 240 150 220 165 160 S220 120 300 110" fill="none" stroke="#38779F" stroke-width="5" stroke-linecap="round" stroke-dasharray="1 10"/>
<path d="M95 300 C110 240 150 220 165 160" fill="none" stroke="#38779F" stroke-width="5" stroke-linecap="round"/>
<circle cx="95" cy="300" r="18" fill="#1C455F"/><circle cx="95" cy="300" r="7" fill="#FFDC6E"/>
<circle cx="300" cy="110" r="16" fill="#E4362F"/><circle cx="300" cy="110" r="6" fill="#FFFFFF"/>
<circle cx="165" cy="160" r="22" fill="#FFFFFF" stroke="#38779F" stroke-width="3"/>
<g transform="translate(153 148)" fill="none" stroke="#38779F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5" cy="17" r="3.5"/><circle cx="19" cy="17" r="3.5"/><path d="M15 6h3l3 8M5 17 8.5 9h6L18 17"/></g>`;

export const MapIllustration = ({ height = 380 }: { height?: number }) =>
  createElement('svg', {
    viewBox: '0 0 390 380',
    width: '100%',
    height,
    preserveAspectRatio: 'xMidYMid slice',
    'aria-hidden': true,
    style: { display: 'block', position: 'absolute', top: 0, left: 0 },
    // Trusted, static markup copied from the design file.
    dangerouslySetInnerHTML: { __html: MAP_SVG },
  });
